import { createLogic } from 'redux-logic'
import { AppState, LogicDeps } from '@chegg-wt/core/state'
import { getType } from 'typesafe-actions'
import { FSACreatorPayload } from '@chegg-wt/core/state/types'
import { UnlockCompleteActions } from '@chegg-wt/core/components/Modals/UnlockAccountGateModal/types'
import {
  syntheticLocationChange,
  resetSyntheticLocationChange,
} from '@chegg-wt/core/state/instrumentation/actions'
import { formSubmit } from '../form/actions'
import { unlockActivityCompleted, openModal, closeModal } from './actions'
import { modalSyntheticRouteNameSelector } from './selectors'

export const unlockActivityCompleteLogic = createLogic<
  AppState,
  FSACreatorPayload<typeof unlockActivityCompleted>,
  any,
  LogicDeps
>({
  type: getType(unlockActivityCompleted),
  process({ action }, dispatch, done) {
    const { completionAction } = action.payload
    if (completionAction === UnlockCompleteActions.FORM_SUBMIT) {
      // timeout to see toast message when ad ends
      setTimeout(() => {
        dispatch(formSubmit())
        done()
      }, 1000)

      return
    }
    done()
  },
})

export const openModalLogic = createLogic<
  AppState,
  FSACreatorPayload<typeof openModal>,
  any,
  LogicDeps
>({
  type: getType(openModal),
  process({ action }, dispatch, done) {
    const { syntheticRouteName } = action.payload
    if (syntheticRouteName) {
      dispatch(syntheticLocationChange({ routeName: syntheticRouteName }))
    }
    done()
  },
})

export const closeModalLogic = createLogic<
  AppState,
  FSACreatorPayload<typeof closeModal>,
  any,
  LogicDeps
>({
  type: getType(closeModal),
  validate({ getState, action }, allow, reject) {
    const syntheticRouteName = modalSyntheticRouteNameSelector(getState())
    if (syntheticRouteName) {
      allow(action)
    } else {
      reject(action)
    }
  },
  process(_, dispatch, done) {
    dispatch(resetSyntheticLocationChange())
    done()
  },
})
